function userPermissions(user) {
  return Array.isArray(user?.permissions) ? user.permissions : [];
}

function hasAnyPermission(user, names) {
  if (user?.is_superuser) return true;
  const perms = userPermissions(user);
  return names.some((name) => perms.includes(name));
}

/** Firemný portál – zoznam/detail CRM tiketov (service_task*, nie CRM modul). */
export function hasFpCrmAccess(user) {
  return hasAnyPermission(user, [
    'access service_task',
    'access service_task-complete-list',
    'access maintenance',
  ]);
}

export function hasFpCrmEdit(user) {
  return hasAnyPermission(user, [
    'edit service_task',
    'edit service_task-complete-list',
    'edit maintenance',
  ]);
}

export function hasFpCrmCompleteList(user) {
  return hasAnyPermission(user, [
    'access service_task-complete-list',
    'access customer_management-complete-list',
  ]);
}

export function hasFpCrmDelete(user, { mineOnly = false } = {}) {
  if (mineOnly) {
    return hasAnyPermission(user, [
      'delete service_task',
      'delete maintenance',
    ]);
  }
  return hasAnyPermission(user, [
    'delete service_task-complete-list',
    'delete maintenance',
  ]);
}

/** CRM modul – Správa zákazníkov / komunikácia (customer_management*). */
export function hasCrmModuleAccess(user) {
  return hasAnyPermission(user, [
    'access customer_management',
    'access customer_management-complete-list',
  ]);
}

export function hasCrmModuleEdit(user) {
  return hasAnyPermission(user, [
    'edit customer_management',
    'edit customer_management-complete-list',
  ]);
}

export function hasCrmModuleAdd(user) {
  return hasAnyPermission(user, [
    'add customer_management',
    'add customer_management-complete-list',
  ]);
}

export function hasCrmModuleCompleteList(user) {
  return hasAnyPermission(user, [
    'access customer_management-complete-list',
    'access service_task-complete-list',
  ]);
}

export function hasCrmModuleDelete(user, { mineOnly = false } = {}) {
  if (mineOnly) {
    return hasAnyPermission(user, [
      'delete customer_management',
    ]);
  }
  return hasAnyPermission(user, [
    'delete customer_management-complete-list',
  ]);
}

/** Otvorenie CRM detailu z notifikácie / deep linku – FP kontext ak nemá CRM modul. */
export function resolveCrmTicketDetailPortalView(user) {
  if (hasCrmModuleAccess(user)) return false;
  return hasFpCrmAccess(user);
}
